<template>
  <div>
    <div v-if="step == 0">
      <app-step0 :desc="tadrisInfo.Description" @nextStep="nextStep" />
    </div>
    <div v-else-if="step == 1">
      <app-step1 :items="tadrisDoreh" @nextStep="nextStep" @prevStep="prevStep" />
    </div>
    <div v-else-if="step == 2">
      <app-step2 :items="dorehSchools" @nextStep="nextStep" @prevStep="prevStep" />
    </div>
    <div v-else-if="step == 3">
      <app-step3 :doreh="selectedDoreh" :schools="selectedSchools" @nextStep="nextStep" @prevStep="prevStep" />
    </div>
  </div>
</template>

<script>
import Step0 from "./Step0";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";

import { saveRequest } from "@/api/tadris";
export default {
  data() {
    return {
      step: 0,
      dorehFetched: false,
      schoolFetched: false,
      selectedDoreh: null,
      selectedSchools: [],
    };
  },
  components: {
    appStep0: Step0,
    appStep1: Step1,
    appStep2: Step2,
    appStep3: Step3,
  },
  methods: {
    nextStep(param) {
      switch (Number(this.step)) {
        case 0:
          if (!this.dorehFetched) {
            this.$store.dispatch("getTadrisDoreh").then(() => {
              this.dorehFetched = true;
            });
          } else {
            if (this.tadrisDoreh.length == 0) {
              this.$store.commit(
                "SET_SNACKBAR_TEXT",
                "دوره ای برای تدریس وجود ندارد."
              );

              return;
            }
          }
          break;
        case 1:
          this.selectedDoreh = param;
          if (!this.schoolFetched) {
            this.$store
              .dispatch("getDorehSchool", param.SrlLearnningGroup)
              .then(() => {
                this.schoolFetched = true;
              });
          } else {
            if (this.dorehSchools.length == 0) {
              this.$store.commit(
                "SET_SNACKBAR_TEXT",
                "در این دوره، مدرسه ای برای تدریس وجود ندارد."
              );

              return;
            }
          }

          break;
        case 2:
          this.selectedSchools = param;

          break;
        case 3:
          var strSchools = [];
          for (var i = 0; i < this.selectedSchools.length; i++) {
            strSchools.push(this.selectedSchools[i].FSerial);
          }
          this.$store.commit("SET_API_RUNNING", true);
          saveRequest(this.selectedDoreh.FSerial, strSchools.join(), param)
            .then((response) => {
              const data = response.data;
              this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
              this.$store.commit("SET_API_RUNNING", false);
              if (data.Success) {
                this.goToIndex();
              }
            })
            .catch((error) => {
              this.$store.commit(
                "SET_SNACKBAR_TEXT",
                "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
              );
            });
      }
      if (this.step < 3) {
        this.$router.push({
          query: {

            step: ++this.step
          }
        });
      }
    },
    prevStep() {
      this.$router.push({
        query: {

          step: --this.step
        }
      });
    },

    goToIndex() {
      this.$store.commit("SET_DIALOG_SHOW", false);
      this.$router.push({ path: "/index" });
    },
  },

  created() {
    
    this.$store.dispatch("getTadrisInfo");
  },
  computed: {
    tadrisInfo() {
      return this.$store.getters.tadrisInfo;
    },
    tadrisDoreh() {
      return this.$store.getters.tadrisDoreh;
    },
    dorehSchools() {
      return this.$store.getters.dorehSchool;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },

  watch: {

    '$route'(to, from) {
      this.step = this.$route.query.step ? Number(this.$route.query.step) : 0;
      window.scrollTo(0, 0)

    }
  },
};
</script>
